'use client';

import dynamic from 'next/dynamic';

export const GoldTrophy = dynamic(() => import('./GoldTrophy'));
export const SpriteConceptDemo = dynamic(
  () => import('./SpriteConceptDemo')
);
export const TwitterLikeAnimation = dynamic(
  () => import('./TwitterLikeAnimation')
);

export const ObjectPositionDemo = dynamic(
  () => import('./ObjectPositionDemo')
);

export const StepsTimingGraph = dynamic(
  () => import('./StepsTimingGraph')
);
